import {Entity} from '@s-ui/domain'

/**
 * @implements Entity
 */
export default class ArticleDetailEntity extends Entity {}
